export default "__VITE_ASSET__CVFbWHC___"